import React, { useState } from 'react'
import { AnexosForm } from '.'
import AnexosList from './AnexosList'
import { Grid } from '@material-ui/core'

const AnexosCard = props => {
  const [status, setStatus] = useState('list')

  return (
    <Grid container>
      {status === 'list' ? (
        <AnexosList {...props} onClickNew={() => setStatus('new')} />
      ) : (
        <AnexosForm {...props} onGoBack={() => setStatus('list')} />
      )}
    </Grid>
  )
}
export default React.memo(AnexosCard)
